<app-dropdown-with-overlay-options-list *ngIf="inventoryLocationsEnabled$ | async" 
    class="users"
    [firstOptionIsSelectedByDefault]="true"
    [isOptionObject]="true"
    [isLoading]="loading$ | async"
    [label]="label"
    [options]="filteredInventoryLocations$ | async"
    [formControl]="formControl"
    [suppressObjectDescription]="!showDescription"
    (chosenOption)="focus(); optionChosen.next($event);"
    [highlightFocusedInput]="true"
    [tabInd]="tabInd"
    #dropDown
>
</app-dropdown-with-overlay-options-list>
